/**
 * @type {import('./index.d').translateWithComponent}
 */
export const translateWithComponent = (str, obj) => {
  const regex = /\{\{(.*?)\}\}/g;

  return str.replace(regex, (match, key) => {
    // Check if the key exists in the object
    key = key?.trim();
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      return obj[key];
    } else {
      // Key not found, return the original string inside {{ }}
      return match;
    }
  });
};

/**
 * @type {import('./index.d').translateByKey}
 */
export const translateByKey = (context, key = '', defaultValue = '') => {
  if (!context?.app?.translation?.[key]) {
    return defaultValue;
  }

  return context.app.translation[key];
};
